function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivelitVedleSebeEdRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2342.5568 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Components"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_7bf536dc-90a5-4ec2-bcc5-59ac36fd0c08_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0,160v120h140.0001c66.2741,0,119.9999-53.7259,119.9999-120H0Z",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 120,
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 480,
    width: 260,
    height: 120,
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260,440c0-66.2741-53.7258-120-119.9999-120H0v120h260Z",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300,480v119.2627c89.9176-5.9253,169.0222-51.3959,220.0031-119.2627h-220.0031Z",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300,.7373v119.2627h220.0031C469.0222,52.1332,389.9176,6.6626,300,.7373Z",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.3271,440c19.1632-36.2415,31.0931-76.8701,33.9355-120h-159.2628c-66.2741,0-119.9999,53.7259-119.9999,120h245.3271Z",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300,160c0,66.2741,53.7258,120,119.9999,120h159.2628c-2.8424-43.1299-14.7723-83.7585-33.9355-120h-245.3271Z",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m931.7318,381.595c51.6145,0,81.9952-29.5803,81.9952-81.1948s-30.3807-82.0115-81.9952-82.0115h-32.4224v163.2063h32.4224Zm151.6094-81.1948c0,83.2202-57.609,140.4208-147.2319,140.4208h-105.2217V159.9794h105.2217c89.623,0,147.2319,56.7923,147.2319,140.4208",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1121.7744,
    y: 159.9696,
    width: 68.4219,
    height: 280.8579,
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1431.0545 159.9745 1503.4944 159.9745 1403.8589 440.8324 1318.2539 440.8324 1218.6348 159.9745 1291.434 159.9745 1361.0483 372.0185 1431.0545 159.9745",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1900.0364 159.9745 1900.0364 388.0092 1989.6594 388.0092 1989.6594 440.8324 1831.6145 440.8324 1831.6145 159.9745 1900.0364 159.9745",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2023.3982,
    y: 159.9696,
    width: 68.4219,
    height: 280.8579,
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2125.3188 159.981 2125.3188 214.7806 2199.7351 214.7806 2199.7351 440.8389 2268.1243 440.8389 2268.1243 214.7806 2342.5568 214.7806 2342.5568 159.981 2125.3188 159.981",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1583.2372,273.6619h133.2339c-1.029-36.9958-30.3807-60.2877-66.8537-60.2877-33.9578,0-60.794,21.7891-66.3802,60.2877m68.3893,171.2261c-81.5705,0-140.8292-56.7433-140.8292-144.8799,0-88.6756,57.7722-144.8962,140.8292-144.8962,81.0478,0,138.2973,55.2242,138.2973,138.8037,0,9.1305-.5063,18.2611-2.0091,27.3426h-205.1838c3.5443,41.5529,31.9161,64.8447,67.3928,64.8447,30.3807,0,47.1064-15.1903,56.2369-33.9088h76.4907c-15.223,51.6635-61.8231,92.6937-131.2249,92.6937",
    style: {
      fill: "#808080",
      strokeWidth: 0
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivelitVedleSebeEdRgb);
export default __webpack_public_path__ + "static/media/divelit-vedle-sebe-šedé-rgb.18118927932c1f0ddd9f8d9901f6dc8f.svg";
export { ForwardRef as ReactComponent };